import React, { Component } from "react";
import axios from "axios";
import Collapsible from "react-collapsible";
import Moment from "moment";

import {
  SwatchColorPicker,
  IconButton,
  IIconProps,
  Dropdown,
  IDropdownStyles,
  IDropdownOption,
  Stack,
  IStackTokens,
  DetailsRow,
  ScrollablePane,
  IScrollablePaneStyles,
  Icon,
  Text,
  Link,
} from "office-ui-fabric-react";

import { Sticky, StickyPositionType } from "office-ui-fabric-react/lib/Sticky";
import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";

import { initializeIcons } from "@uifabric/icons";

import "../styles/taskview.css";

import ActiveTask_VTL from "./Vertical-Timeline/activetask";
import CompletedTask_VTL from "./Vertical-Timeline/completedtask";
import AllTask_VTL from "./Vertical-Timeline/alltask";
import AllTaskTL from "./Timeline/alltask-tl";
import CompletedTaskTl from "./Timeline/completedtask-tl";
import CheckboxComp from "./checkboxComponent";
import { EventEmitter } from "./events";

import {
  MomentDateFormat,
  TimelineItemDateText,
} from "./Vertical-Timeline/CustomFuntion";

initializeIcons();

interface IState {
  isLoaded: boolean;
  overdueCount: number;
  overdueText: string;
  overdueItems: any;
  currentCount: number;
  currentText: string;
  currentItems: any;
  upcomingCount: number;
  upcomingText: string;
  upcomingItems: any;
  completedItems: any;
  allItems: any;
  currentMonth: string;
  currentDate: Date;
  IsTimeLineView: boolean;
  viewList: string;
  workFlowURL: string;
  documentURL: string;
  userKey: string;
  displayName: string;
  userEmail: string;
}

const statusIconClass = mergeStyleSets({
  complete: [{ color: "#2ECC71", fontSize: "0.8em" }],
  open: [{ color: "gold", fontSize: "0.8em" }],
  close: [{ color: "red", fontSize: "0.8em" }],
  overdue: [{ color: "red", fontSize: "0.8em" }],
});

const IsTimeLineIcon: IIconProps = {
  id: "IsTimeLine",
  iconName: "AlignHorizontalLeft",
  title: "Timeline",
};

const IsListViewIcon: IIconProps = {
  id: "IsTimeLine",
  iconName: "CustomList",
  title: "Timeline",
};

const dropdownStyles: Partial<IDropdownStyles> = {
  dropdown: {
    width: "100%",
    padding: 2,
  },
};

const options: IDropdownOption[] = [
  { key: "alltask", text: "All My Tasks" },
  { key: "activetask", text: "My Active Tasks" },
  { key: "completedtask", text: "My Completed Tasks" },
];

const headerStack: IStackTokens = {
  padding: `${10}px ${0}px ${10}px ${5}px`,
};

const classNames = mergeStyleSets({
  pane: {
    maxWidth: 400,
  },
});

const scrollablePaneStyles: Partial<IScrollablePaneStyles> = {
  root: classNames.pane,
};

class TaskView extends Component<{}, IState> {
  private _columns: any[];

  constructor(props: any) {
    super(props);

    this.state = {
      isLoaded: false,
      overdueCount: 5,
      overdueText: "Overdue",
      overdueItems: [],
      currentCount: 10,
      currentText: "",
      currentItems: [],
      upcomingCount: 80,
      upcomingText: "Upcoming",
      upcomingItems: [],
      completedItems: [],
      allItems: [],
      currentMonth: "",
      currentDate: new Date(),
      IsTimeLineView: false,
      viewList: "activetask",
      workFlowURL: "",
      documentURL: "",
      userKey: "",
      displayName: "",
      userEmail: "",
    };

    this._columns = [
      {
        key: "status",
        name: "Status",
        fieldName: "Status",
        minWidth: 20,
      },
      {
        key: "date",
        name: "Date",
        fieldName: "Date",
        minWidth: 50,
      },
      ];
      EventEmitter.subscribe('onMarkCompleted', (event: any) => {
          this.onMarkCompleted(event);
      }); 
    }

    onMarkCompleted = (event: any) => {
        var current = this.state.currentItems;
        var overdue = this.state.overdueItems;
        var upcoming = this.state.upcomingItems;

        for (var x = 0; x < current.length; x++) {
            if (current[x].id == event) {
                current.splice(x, 1);
                break;
            }
        }
        for (var x = 0; x < overdue.length; x++) {
            if (overdue[x].id == event) {
                overdue.splice(x, 1);
                break;
            }
        }
        for (var x = 0; x < upcoming.length; x++) {
            if (upcoming[x].id == event) {
                upcoming.splice(x, 1);
                break;
            }
        }

        this.setState({
            currentItems: current,
            overdueItems: overdue,
            upcomingItems: upcoming
        });



    }

    componentDidMount() {
        this.getUserCredentials().then((res) => {
            let user = JSON.parse(res);
            this.setState(
                {
                    userKey: user.id,
                    displayName: user.name,
                    userEmail: user.userName,
                    workFlowURL: this.props.workFlowURL,
                },
                () => {
                    this.getAPI().then((apiRes) => {
                        let api = JSON.parse(apiRes);
                        this.setState(
                            {
                                documentURL: api.matterdetail,
                            },
                            () => {
                                this._getDataList();
                            },
                        );
                    });
                },
            );
        });
    }

  getUserCredentials() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("userSession"));
    });
  }

    getAPI() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("api"));
    });
  }

  _getDataList() {
    axios
      .get(this.state.workFlowURL + "&email=" + this.state.userEmail)
        .then((response) => {
        this._generateOverdueItem(response.data);
        this._generateUpcoming(response.data);
        this._generateCurrent(response.data);
            this._generateCompleted(response.data);

        this.setState({
          allItems: response.data,
          isLoaded: true,
        });
      });
  }

  _generateOverdueItem(currItem: any) {
    let tempOverdue = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status == "Open") {
        let itemDate = Moment(
          currItem[c].data.event.dueDate,
          "YYYY-MM-DD",
        ).toDate();
        if (itemDate < this.state.currentDate) {
          if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
            if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
              tempOverdue.push(currItem[c]);
            }
          } else {
            tempOverdue.push(currItem[c]);
          }
        }
      }
    }
    this.setState({
      overdueItems: tempOverdue,
    });
  }

  _generateCurrent(currItem: any) {
    let tempCurrent = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status == "Open") {
        let itemDate = Moment(
          currItem[c].data.event.dueDate,
          "YYYY-MM-DD",
        ).toDate();
        if (
          itemDate.getMonth() === this.state.currentDate.getMonth() &&
          itemDate.getFullYear() === this.state.currentDate.getFullYear()
        ) {
          tempCurrent.push(currItem[c]);
        }
      }
    }
    this.setState({
      currentItems: tempCurrent,
    });
  }

  _generateUpcoming(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status == "Open") {
        let itemDate = Moment(
          currItem[c].data.event.dueDate,
          "YYYY-MM-DD",
        ).toDate();
        if (itemDate > this.state.currentDate) {
          if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
            if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
              tempUpcoming.push(currItem[c]);
            }
          } else {
            tempUpcoming.push(currItem[c]);
          }
        }
      }
    }
    this.setState({
      upcomingItems: tempUpcoming,
    });
  }

  _generateCompleted(currItem: any) {
    let tempCompleted = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status === "Complete") {
        tempCompleted.push(currItem[c]);
      }
    }

    this.setState({
      completedItems: tempCompleted,
    });
  }

  _getStatusIcon(status: string) {
    if (status === "Open") {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.open} />
      );
    } else if (status === "Complete") {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.complete}
        />
      );
    } else {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.close} />
      );
    }
  }

  getStatusIcon(dueDate: any) {
    let itemDate = Moment(dueDate, "YYYY-MM-DD").toDate();
    if (itemDate < this.state.currentDate) {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.overdue}
        />
      );
    } else {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.open} />
      );
    }
  }

  generateOverDueItems() {
    this.state.overdueItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.overdueItems.map((items: any, index: any) => {
      return (
        <React.Fragment>
          {items.data.event.status === "Open" ? (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
                <Icon
                  iconName="StatusCircleInner"
                  className={statusIconClass.overdue}
                />
              </div>
              <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
                <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
              </div>
              <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
                <Collapsible
                  key={items.id}
                  className={"Collapsible-TimeLineItem"}
                  contentOuterClassName={"Collapsible-Item"}
                  trigger={items.data.event.task}
                  onOpen={() => {}}
                          >
                <CheckboxComp key={items.id} data={items} />
                  <Link
                    type="submit"
                    href={
                      this.state.documentURL +
                      "/Matter?matterCode=" +
                      items.data.matterCode +
                      "#/Workflow"
                    }
                    target="_blank"
                  >
                    {items.data.matterCode}
                  </Link>
                  <span>{" - "}</span> {items.data.description}
                  <hr className="line-item" />
                  {items.data.event.assignTo.length > 0 ? (
                    <b className="assignToLabel">{"AssignTo: "} </b>
                  ) : (
                    ""
                  )}
                  {items.data.event.assignTo.map(
                    (assignto: any, index: any) => {
                      return <i key={items.id + index}>{assignto.name}, </i>;
                    },
                  )}
                </Collapsible>
              </div>
            </div>
          ) : null}
        </React.Fragment>
      );
    });
  }

  generateCurrentItems() {
    this.state.currentItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.currentItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this.getStatusIcon(items.data.event.dueDate)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
                  >
            <CheckboxComp key={items.id} data={items} />
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateUpcomingItems() {
    this.state.upcomingItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.upcomingItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
                  >
           <CheckboxComp key={items.id} data={items} />
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  OnViewChange = () => {
    this.setState({ IsTimeLineView: !this.state.IsTimeLineView });
  };

  onTaskViewChanged = (
    event: React.FormEvent<HTMLDivElement>,
    item: IDropdownOption,
  ): void => {
    this.setState({
      viewList: item.key,
    });
  };

  _activeTaskView = () => {
    return (
      <div className={"active-task-line"}>
        <Collapsible
          id="overdue"
          className="overdue-text"
          triggerOpenedClassName="overdue-text-span"
          open={false}
          trigger={
            this.state.overdueText +
            "  (" +
            this.state.overdueItems.length +
            ")"
          }
        >
          <div className="ms-Grid task-grid" dir="ltr">
            {this.generateOverDueItems()}
          </div>
        </Collapsible>
        <Collapsible
          className="current-text"
          triggerOpenedClassName="current-text-span"
          trigger={
            Moment(this.state.currentDate).format("MMMM").toString() +
            "  (" +
            this.state.currentItems.length +
            ")"
          }
          open={true}
        >
          <div className="ms-Grid task-grid" dir="ltr">
            {this.generateCurrentItems()}
          </div>
        </Collapsible>
        <Collapsible
          className="upcoming-text task-grid"
          triggerOpenedClassName="upcoming-text-span"
          open={false}
          trigger={
            this.state.upcomingText +
            "  (" +
            this.state.upcomingItems.length +
            ")"
          }
        >
          <div className="ms-Grid task-grid" dir="ltr">
            {this.generateUpcomingItems()}
          </div>
        </Collapsible>
      </div>
    );
  };

  _taskView = () => {
    if (this.state.viewList === "activetask") {
      return this._activeTaskView();
    } else if (this.state.viewList === "completedtask") {
      return (
        <CompletedTaskTl items={this.state.completedItems}></CompletedTaskTl>
      );
    } else if (this.state.viewList === "alltask") {
      return <AllTaskTL items={this.state.allItems}></AllTaskTL>;
    }

    return this._activeTaskView();
  };

  _timelineView = () => {
    if (this.state.viewList === "activetask") {
      return <ActiveTask_VTL items={this.state.allItems}></ActiveTask_VTL>;
    } else if (this.state.viewList === "completedtask") {
      return (
        <CompletedTask_VTL items={this.state.allItems}></CompletedTask_VTL>
      );
    } else if (this.state.viewList === "alltask") {
      return <AllTask_VTL items={this.state.allItems}></AllTask_VTL>;
    }

    return <ActiveTask_VTL></ActiveTask_VTL>;
  };

  public render() {
    const { isLoaded } = this.state;
    if (!isLoaded) return <div>Loading...</div>;
    else {
      return (
        <div className="ms-Grid task-container" dir="ltr">
          <div className="ms-Grid-row task-header">
            <Stack
              className="task-header-stack"
              horizontal
              tokens={headerStack}
            >
              <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg10 left-col">
                <Dropdown
                  className="icon-holder"
                  defaultSelectedKey="activetask"
                  options={options}
                  styles={dropdownStyles}
                  onChange={this.onTaskViewChanged}
                />
              </div>
              <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg2 rigth-col">
                {this.state.IsTimeLineView === false ? (
                  <div>
                    <div className="Timeline-btn">
                      <IconButton
                        className="icon-holder"
                        iconProps={IsTimeLineIcon}
                        onClick={this.OnViewChange}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="Timeline-btn">
                      <IconButton
                        className="icon-holder"
                        iconProps={IsListViewIcon}
                        onClick={this.OnViewChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Stack>
          </div>
          {this.state.IsTimeLineView === false
            ? this._taskView()
            : this._timelineView()}
        </div>
      );
    }
  }
}

export default TaskView;
